import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getRoute } from '../api/routes';
import api from '../Interceptor';
import { useSelector } from 'react-redux';

const useProjectExpenses = (selectedProject, selectedMilestone, startDate, endDate) => {
  const user = useSelector(state => state.auth.user)
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchExpenses = async () => {
    try {
      setLoading(true);
      let url = `${getRoute('users', `${user.userRole.name}`, 'expenses', false)}`;
      let params = [];
      if (selectedProject !== 'All') {
        params.push(`projectId=${selectedProject}`);
      }
      if (selectedMilestone !== 'All') {
        params.push(`milestoneId=${selectedMilestone}`);
      }
      if (startDate && startDate.trim() !== '') {
        params.push(`startDate=${startDate}`);
      }
      if (endDate) {
        params.push(`endDate=${endDate}`);
      } else {
        params.push(`endDate=${new Date().toISOString().split('T')[0]}`);
      }
      params.push('currencyView=BaseCurrency');
      if (params.length > 0) {
        url += `?${params.join('&')}`;
      }
      const response = await api.get(url);
      const payload = response?.data;
      if (Array.isArray(payload)) {
        setExpenses(payload);
      } else if (payload && Array.isArray(payload.expenses)) {
        setExpenses(payload.expenses);
      } else {
        toast.error('Invalid data format received from the server.');
        setExpenses([]);
      }
    } catch (error) {
      toast.error('Failed to fetch expenses.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      fetchExpenses();
  }, [endDate]);

  return { expenses, loading, refetchExpenses: fetchExpenses };
};

export default useProjectExpenses;
